<template>
  <order-form v-if="order" @submit="submit" :init-order="order" :init-product="product" :val-errors="valErrors"
    :settings="settings" submit-text="Erstellen" />
</template>

<script>
import OrderForm from './order-form'

export default {
  components: { OrderForm },
  data() {
    return {
      valErrors: [],
      order: {
        products: [],
        supplier: null,
        contact_person: null,
        append_prices: true,
        email: null,
        email_subject: null,
        warehouse_id: null
      },
      product: null,
      settings: null
    }
  },
  methods: {
    async submit(order) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.post('orders', order).then(({ data }) => {
        this.$notify({
          message: 'Bestellung erfolgreich erstellt.',
          type: 'success'
        })
        this.$router.push(`/orders/${data.id}`)
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    async getOrder(order_id) {
      await this.initCsrf()
      await this.$http.get(`orders/get-order/${order_id}`).then(({ data }) => {
        this.order = data
      }).catch(({ response }) => console.error(response))
    }
  },
  async created() {
    let fetchSupplier = Promise.resolve()
    let supplier = null
    let contactPerson = null
    let email = null
    if (this.$route.query['product']) {
      this.product = this.$route.query['product']
    }
    const settingsResponse = await this.$http.get('/settings').then(({ data }) => {
      this.settings = data
    })

    if (this.$route.query['supplier']) {
      fetchSupplier = this.$http.get(`/suppliers/${this.$route.query['supplier']}`).then(({ data }) => {
        supplier = data
        email = data.email
      })
    }

    await fetchSupplier
    if (this.$route.query.orderId) {
      await this.getOrder(this.$route.query.orderId)
    } else {
      this.order = {
        products: [],
        supplier,
        contact_person: contactPerson,
        append_prices: true,
        email,
        email_subject: this.settings.email_subject,
        warehouse_id: null,
        supplier_id: null
      }

    }

  }
}
</script>

<style></style>
